import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const QR27PUSHSuccess: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(670);
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'QR27 PUSH CTA button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    window.location.href = 'https://www.pushexperiential.com/freshthyme'
  }

  return (
    <IonPage className={`lay--${qrDetails?.eventQrId}`}>

      <IonContent className={`lay__container--${qrDetails?.eventQrId} success-page`}>
        <div className="lay__background">
          <img src="https://pulseqr.b-cdn.net/qr27PUSH/Background--no-logo.png" style={{height:'800px'}} />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>
            {true && 
              <div className="lay__logo" style={{height: '22px'}}>
                <div  className="">
                  <img style={{paddingTop: '20px', height: '22px', marginTop: '25px'}} src="https://pulseqr.b-cdn.net/qr27PUSH/logo.png" />
                </div>
                
              </div>
            }
            <div className="img__first" style={{marginTop: '40px', marginBottom: '20px', marginLeft: 0, marginRight: 0}}>
              <div className="talent-signup__section-title">
                <img src="https://pulseqr.b-cdn.net/qr27PUSH/p6-img1.png" />
              </div>
            </div>

            <div className="img__inline" style={{marginTop: '10px', zIndex: 3, width: '280px'}}>
              <div onClick={trackCTAClick} style={{cursor: 'pointer'}}>
                <img src="https://pulseqr.b-cdn.net/qr27PUSH/CTA-Submit6.png" />
              </div>
            </div>

          </div>}
          
      </IonContent>

    </IonPage>
  );
};

export default QR27PUSHSuccess;
